/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { BaseUser } from "src/classes/user";
import { Username } from "src/components/Shared/User/Username";

interface Props {
  users: BaseUser[];
}
export function LikedBy({ users }: Props) {
  return (
    <LikedByWrapper>
      {users.map((user) => (
        <Username user={user} key={user.snapshot.id} style={{ padding: "2px" }} />
      ))}
    </LikedByWrapper>
  );
}

const LikedByWrapper = styled.div`
  overflow-y: auto;
  max-height: 180px;
  display: flex;
  flex-wrap: wrap;
  padding: 10px 14px;
`;
